// extracted by mini-css-extract-plugin
export var container = "styles-module__container___f1pCk";
export var small = "styles-module__small___vNTEe";
export var cardRadioContainer = "styles-module__cardRadioContainer___X0_z_";
export var radioButton = "styles-module__radioButton___ylQfl";
export var label = "styles-module__label___xZXf0";